import styles from './SecondaryCTA.module.css';

const SecondaryCTA = props => {

	return (
		<button 
			className={`btn btn-outline-primary ${styles.SecondaryCTA}`} 
			onClick={props.clickHandler}
		>
			{props.children}
		</button>
	)
}

export default SecondaryCTA ;